import { render } from "./FormRadioButtonsFieldComponent.vue?vue&type=template&id=3841d2ea&scoped=true"
import script from "./FormRadioButtonsFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormRadioButtonsFieldComponent.vue?vue&type=script&lang=js"

import "./FormRadioButtonsFieldComponent.vue?vue&type=style&index=0&id=3841d2ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3841d2ea"]])

export default __exports__